import React from 'react';
import { Link } from 'react-router-dom';
import AnnouncementBar from '../components/AnnouncementBar.jsx';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';
export default function SouthAsianSisters() {
  return <div className="min-h-screen bg-white" data-name="South Asian Sisters Page">
      {/* Announcement Bar */}
      <div className="fixed top-0 left-0 right-0 z-[60]">
        <AnnouncementBar />
      </div>
      
      {/* Transparent Navigation */}
      <div className="absolute top-0 left-0 right-0 z-50">
        <Navigation transparent={true} />
      </div>

      {/* Hero Section with Background Image */}
      <section className="relative pt-48 pb-24 px-6 bg-cover bg-center" style={{
      backgroundImage: "url(\"https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/user_33tbl7B6e1bXN6KW4wjrevvqrth/cmhd1gtfc0001vb0yeeofdn9z/images/istock-1166715102-1wdjpln3pvkj.jpg\")"
    }} data-name="Hero Section">
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40"></div>
        
        <div className="relative max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">South Asian Sisters</h1>
          <p className="text-2xl md:text-3xl mb-4 font-light">A Circle for Cultural Healing</p>
          <p className="text-xl md:text-2xl mb-8 font-semibold">
            For South Asian women navigating cultural expectations<br />
            Wednesdays • 10:00 AM PST
          </p>
          <a target="_blank" rel="noopener noreferrer" className="inline-block bg-sage-400 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-sage-500 transition-colors" data-tracking-id="link-0cb1819dc7ce144f" href="https://calendly.com/yphilipos/south-asian-sisters">
            First Session Free. Join Today
          </a>
        </div>
        
        {/* Image Attribution */}
        <span data-editor-skip="true" className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
          <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
          <span className="hidden drop-shadow-md group-hover/attribution:block">
            Image on{' '}
            <a href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
            color: '#fff',
            textDecoration: 'none'
          }} data-tracking-id="link-717f1dbe5006ae70">
              Unsplash
            </a>
            {' '}by{' '}
            <a href="https://unsplash.com/@priscilladupreez?utm_source=makerdevi&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
            color: '#fff',
            textDecoration: 'none'
          }} data-tracking-id="link-6b3e2973c2e97b84">
              Priscilla Du Preez
            </a>
          </span>
        </span>
      </section>

      {/* Sanctuary Description */}
      <section className="py-16 px-6 bg-sage-50" data-name="Sanctuary Description">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-2xl leading-8 text-gray-800 leading-relaxed mb-8 mt-0 ml-0 mr-0 pt-[5px] pb-[5px] pl-[5px] pr-[5px]">
            A space where your multiple identities are&nbsp;honored<br />
            and your individual truth is&nbsp;celebrated.
          </p>
          <p className="text-xl leading-7 leading-7 text-gray-700 leading-relaxed mt-0 mb-0 ml-0 mr-0 pt-[3px] pb-[3px] pl-[5px] pr-[5px]">
            For South Asian women ready to navigate the complexity of honoring heritage<br />
            while creating their own&nbsp;path.
          </p>
        </div>
      </section>

      {/* What Makes This Circle Unique */}
      <section className="py-20 px-6 bg-white" data-name="What Makes This Unique">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
            A Space That Gets It
          </h2>

          <div className="space-y-12">
            {/* Cultural Understanding */}
            <div className="bg-sage-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-4 text-sage-700">Cultural Context Matters</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Navigate the unique challenges of South Asian cultural expectations, family dynamics, and generational patterns with others who deeply understand.
              </p>
            </div>

            {/* Safe Space */}
            <div className="bg-warmcream-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-4 text-warmcream-700">Beyond Stereotypes</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Move past the model minority myth, the good daughter narrative, and all the invisible scripts you've been carrying.
              </p>
            </div>

            {/* Bridging Worlds */}
            <div className="bg-sage-50 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-4 text-sage-700">Bridging Two Worlds</h3>
              <p className="text-lg text-gray-700 leading-relaxed">{"Honor your roots while creating a life that feels authentic to you, without having to choose between cultures."}</p>
            </div>
          </div>
        </div>
      </section>

      {/* What We'll Explore */}
      <section className="py-20 px-6 bg-sage-50" data-name="What We'll Explore">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
            Topics We'll Explore Together
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Family expectations vs. personal desires</span>
                </li>
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Navigating arranged marriage pressures</span>
                </li>
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Career choices and parental approval</span>
                </li>
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Cultural guilt and shame patterns</span>
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <ul className="space-y-3 text-gray-700 text-lg">
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Intergenerational trauma</span>
                </li>
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Breaking silence around mental health</span>
                </li>
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Creating boundaries with extended family</span>
                </li>
                <li className="flex items-start">
                  <span className="text-sage-600 mr-3 mt-1">•</span>
                  <span>Reclaiming your authentic self</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Who This Is For */}
      <section className="py-20 px-6 bg-white" data-name="Who This Is For">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-gray-900">
            This Circle Is For You If...
          </h2>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p className="flex items-start">
              <span className="text-sage-600 mr-3 mt-1 text-2xl">✓</span>
              <span>You're tired of explaining your cultural context to people who don't get it</span>
            </p>
            <p className="flex items-start">
              <span className="text-sage-600 mr-3 mt-1 text-2xl">✓</span>
              <span>You feel caught between honoring your family and honoring yourself</span>
            </p>
            <p className="flex items-start">
              <span className="text-sage-600 mr-3 mt-1 text-2xl">✓</span>
              <span>You're ready to heal generational patterns while staying connected to your roots</span>
            </p>
            <p className="flex items-start">
              <span className="text-sage-600 mr-3 mt-1 text-2xl">✓</span>
              <span>You want community with women who share your cultural background and understand the nuances</span>
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section data-name="Final CTA" className="py-16 px-6 bg-[#f3f8ee]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900">{""}</h2>
          <p className="text-lg text-gray-700 mb-8">{""}</p>
          <a target="_blank" rel="noopener noreferrer" className="inline-block bg-sage-400 text-white px-10 py-4 rounded-full text-lg leading-7 font-semibold hover:bg-sage-500 transition-colors ease-in-out duration" data-tracking-id="link-7f8410bff3830e13" href="https://calendly.com/yphilipos/south-asian-sisters">{"First Session Free. Please click here to join."}</a>
        </div>
      </section>

      <Footer />
    </div>;
}